import { StyleSheet } from 'aphrodite'

import headers from './headers'
import list from './list'
import form from './form'
import user from './user'

export default {
  headers: StyleSheet.create(headers),
  list: StyleSheet.create(list),
  form: StyleSheet.create(form),
  user: StyleSheet.create(user)
}



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/style/ColorBlind/index.js